import { trackEvent } from "@/utils/analytics";
import { cls } from "@/utils/util";
import { Link, useLocation } from "react-router-dom";
import HeaderFlag from "@/component/header/HeaderFlag";
import { ChicruitingLogo } from "../Logo";
import { useRecoilValue } from "recoil";
import { tokenState } from "state";

const TabItem = ({
  isActive,
  tab,
  color,
  scrolled,
  onHover,
  width,
}: {
  isActive: boolean;
  tab: { value: string; label: string; url: string; width: number; subTabs: any };
  color: string | null | undefined;
  scrolled: boolean;
  onHover: () => void;
  width: number;
}) => {
  const token = useRecoilValue(tokenState);
  const location = useLocation();
  const isShurink = tab.value === "shurink";
  const isHermannryff = tab.value === "hermannryff";
  return (
    <div
      className="flex items-center whitespace-nowrap"
      style={{ width: width }}
      onMouseEnter={() => onHover()}
    >
      <Link
        className={cls(
          color ? `text-${color}` : "",
          isActive
            ? color
              ? "text-opacity-100 font-bold"
              : "text-primary-800 font-medium"
            : color
            ? "text-opacity-50 font-medium hover:text-opacity-100 hover:font-bold"
            : "font-medium hover:text-primary-800",
          "text-[14px] py-4 flex items-center relative",
          // shurink 탭 스타일
          (isShurink || isHermannryff) &&
            `flex h-[32px] py-[6px] px-[10px] pl-[34px] rounded-[999px] bg-white hover:bg-medi-bg-primaryHover !text-medi-text-primary border border-medi-border-primary overflow-hidden ${
              isShurink ? "w-[88px]" : "w-[92px]"
            }`,
          ((isShurink && isActive) || (isHermannryff && isActive)) &&
            "bg-white border-medi-color-purple-100 border-[1.5px] shadow-[0_0_0_2px_var(--medi-color-purple-100)]",
        )}
        to={tab.url}
        onClick={() =>
          trackEvent("Header Menu Clicked", {
            page_name: location.pathname,
            section_name: `메뉴 > ${tab.label}`,
            button_name: tab.label,
            user_id: token?.uid,
            customer_id: token?.customerId,
          })
        }
      >
        {!scrolled && <HeaderFlag value={tab.value} />}
        {tab.value === "chicruiting" ? <ChicruitingLogo width={74} color={color} /> : tab.label}
        {tab.label === "Q&A/임상" && (
          <div className="h-[15px] ml-1 bg-gradient-to-r from-[#6533E8] to-[#607EE1] px-[3px] text-white rounded-sm flex items-center">
            <span className="w-[10px] h-[10px] bg-[url('/img/ai/icon-badge.svg')] bg-no-repeat bg-center bg-cover"></span>
            <span className="!text-[#fff] text-[11px] font-bold !bg-transparent">AI</span>
          </div>
        )}
        {isShurink && (
          <img
            src="/img/shurink/shurink-icon.png"
            className="w-[22px] h-[27px] absolute left-[10px] bottom-0"
          />
        )}
        {isHermannryff && (
          <img
            src="/img/hermannryff/hermannryff-click-fit2.png"
            className="w-[28.8px] h-[41px] absolute left-[8px] top-0"
          />
        )}
      </Link>
    </div>
  );
};

export default TabItem;
